import React from 'react';
import { makeStyles, Button } from "@material-ui/core";
import { useTranslation } from 'react-i18next';
import FlagstoneTheme from '../../../../Config/flagstoneTheme';
import clsx from 'clsx';

export default function ScissorSwitch(props) {
    const classes = useStyles();
    const { t } = useTranslation();

    return <button className={classes.scissorSwitch} disabled={props.disabled} onClick={props.onChange} style={{backgroundColor:props.disabled && "#00000029"}}>
        <div className={clsx({ ['bottomThumb']: props.checked, ['topThumb']: !props.checked})}></div>
    </button>
}

const useStyles = makeStyles({
    scissorSwitch: {
        height: "75px",
        width: "24px",
        borderRadius: "12px",
        backgroundColor: FlagstoneTheme.palette.primary.main,
        border:"none",
        outline:"none",
        cursor:"pointer",
        marginLeft:"32px"
    },   
});